export const label = {

  //common
  dateFormat:'YYYY-MM-dd',
  filter: 'Filter',
  search: 'Search',
  ok: 'Ok',
  hi: 'Hi',
  all: 'All',
  commands: 'Commands',
  accessRestrictedNotice: 'Access Restricted Notice!',
  licenseExpire: 'Your License has expired. Please Contact your Admin.',
  create:'Create',
  delete:'Delete',
  //statistics
  online: 'Online',
  offline: 'Offline',
  total: 'Total',
  //header
  alarms: 'Alarms',
  warnings: 'Warnings',
  users: 'Users',
  coolers: 'Coolers',
  activeLicense: 'Active License',
  licenseExpired: 'License Expired',
  gracePeriod: 'Grace Period',
  tenantUser: 'Tenant Users',
  logout: 'Logout',
  profileUpdate: 'Profile Update',
  changePassword: 'Change Passowrd',
  changeEmail: 'Change Email',
  processing: 'Processing',
  success: 'Sucess',
  error: 'Error',
  requestSuccessful: 'Request Process Successfully',
  requestUnsucessful: 'Error occurred while processing request, please try again.',
  addedOn: 'Added On',
  modbusSlaveID: 'Modbus slave ID',
  controllerTypeName: 'Controller Type Name',
  deviceType: 'Device Type', // new
  //shell
  menu: 'Menu',
  menuDashboard: 'Home',
  menuManage: 'Manage',
  menuManagement: 'Management',
  menuManageDeviceGroups: 'Device Groups',
  menuUsers: 'User Information',
  menuRules: 'Alarm Rules',
  menuAlarms: 'Alarm Information',
  menuHACCPReport: 'HACCP Report',
  licenseExpireson: 'License Expires On',
  menuBroadcastMessage:'Broadcast Messages',
  menuReport: 'Reports',
  menuDeviceInfo: 'Device Information',
  menuDevice: 'Phone/Tablet',
  menuMaintenance: 'Maintenance',
  menuProfitability: 'Profitability',
  menuDataAnalytics: 'Data Analytics',
  menuExport: 'Export Json',
  menuStatistics: 'Statistics',
  menuGroup: 'Groups',
  menuDataExport: 'Data Export',
  copyClose: 'Copy & Close',
  //admin-dashboard
  tenantList: 'Tenant List',
  btnAdd: 'Add Tenant',
  tableHeaderErpno: 'Erp No',
  tableHeaderTenant: 'Tenant',
  tableHeaderGracePeriod: 'Grace Period',
  tableHeaderLicenseEndDate: 'License End Date',
  tenantSearch: 'Search works on Erp No, Tenant, Geo Location columns',
  selectTenant: 'Select Tenant',

  //tenant-popup
  tenantAdd: 'Add Tenant',
  updateTenant: 'Update Tenant',
  tenantName: 'Tenant',
  tenantEmail: 'Tenant Email',
  erpNumber: 'ERP Number',
  maxCoolers: 'Maximum number of coolers',
  licenseExpiration: 'License Expiration',
  tenantDetails: 'Tenant Details',
  tenantEmailu: 'TENANT EMAIL',
  coolersu: 'COOLERS',
  expireu: 'Expire',
  geoLocationu: 'GEO LOCATION',
  erpnou: 'ERP NO',
  update: 'Update',
  disableTenant: 'Disable Tenant',
  moveCoolers: 'Move Coolers',
  disableTenantText: 'Do you really want to disable',
  moveCooler: 'Move Cooler',
  selectExpiryDate: 'Select Expiry License Date',

  //dashboard
  coolerList: 'Coolers List',
  deviceList: 'Device List',
  allDevices: 'All Devices',
  searchPalce: 'Search works on Device, Groups, Alarms, Country columns',
  tableHeaderCooler: 'Cooler',
  tableHeaderDevice: 'Device',
  tableHeaderLastConnect: 'Last Connected',
  tableHeaderDongleUId: 'Dongle UId',
  tableHeaderAlarm: 'Alarms',
  tableHeaderCountry: 'Country',
  tableHeaderTagAlias: 'Tag/Alias',
  alarmStatus:'Alarm Status',
  tableHeaderDeviceStatus: 'Status',
  tableDataDeviceActive: 'Active',
  tableDataDeviceInActive: 'InActive',
  tableHeaderGroups: 'Group(s)',
  deviceDetails: 'Device Details',
  viewValue: 'View Value',

  //device groups
  dgTblHeaderGroupName: 'Group Name',
  dgTblHeaderDeviceName: 'Device Name',
  dgTblHeaderDescription: 'Description',
  dgTblHeaderTotalDevices: 'Total Devices',
  dgTblHeaderCreatedDate: 'Created Date (UTC)',
  dgTblHeaderAddedBy: 'Added By',
  dgTblHeaderActions: 'Actions',
  dgGroupSearch: 'Search works on Group Name, Description columns',
  dgCreateAddgroupDetails: 'Add Group Details',
  dgEditAddgroupDetails: 'Edit Group Details',
  dgCreateAddGroupName: 'Name of the Group',
  dgCreateGroupBtn: 'Create New Group',
  dgCreateDeviceList: 'Device List',
  dgCreateSelectDevices: 'Select Devices',
  dgGroupInfoModalHeader: 'Group Information',
  dgGroupAddEditDescLabel: 'Add Description',
  addBoradcastmessage:'Add Broadcast Message',

  //New Labels for group
  updateDeviceGroup: 'Update Device Group',
  createDeviceGroup: 'Create Device Group',
  group: 'Group',
  nameofGroup: 'Name of the Group',



  //statistics
  statDeviceCountTitle: 'Device Count',
  statAlarmCountTitle: 'Alarm Count',
  statDeviceStatusTitle: 'Device Status',
  statGroupCountTitle: 'Groups Count', // new
  statDeviceByGroupTitle: 'Device by Group',
  statAlarmsByDeviceStatusTitle: 'Alarms By Device Status',
  statDeviceStatusCountTitle: 'Device Status Count',
  statAlarmsByDeviceOverTime: 'Alarms By Devices Over Time',
  //Range filter labels
  filterRealTime: 'Real Time',
  filterHour: 'Hour',
  filterDay: 'Day',
  filterMonth: 'Month',
  filter24Hour: 'Last 24 Hrs',
  filterWeek: 'Last Week',
  filterLastMonth: 'Last Month',
  filterLast3Month: 'Last 3 Months',
  filterLastYear: 'Last 1 Year',
  filterLast6Month: 'Last 6 Months',


  //users
  userInfor: 'User Information',
  btnAddUser: 'Add New User',
  userSearch: 'Search works on Name, Email, Role, OEM/Parent, and Device columns',
  tableHeaderRole: 'Role',
  tableHeaderEmail: 'Email',
  tableHeaderCoolers: 'Coolers',
  tableHeaderCreateAlarms: 'Create Alarms',
  tableHeaderAccessTo: 'Access To',
  tableHeaderDevices: 'Devices',
  tableHeaderOEM: 'OEM',
  tableHeaderName: 'Name',
  tableHeaderOEMOrParent: 'OEM/Parent',
  createUser: 'Create User',

  //user-popup
  addUserDetails: 'Add User Details',
  updateUserDetails: 'Edit User Details',
  email: 'Email',
  role: 'Role',
  createAlarms: 'Create Alarms',
  accessTo: 'Access To',
  allCountriesSelected: 'All Countries Selected',
  yes: 'Yes',
  no: 'No',
  oem: 'OEM',


  //alarm
  alarmInfo: 'Alarm Information',
  alarmSearch: 'Search works on Device, UID, Geo location, Rule, Resource columns',
  tableHeaderUid: 'UID',
  tableHeaderGeoLocation: 'Geo Location',
  tableHeaderStatus: 'Status',
  tableHeaderAlarmType: 'Severity',
  tableHeaderRule: 'Rule',
  tableHeaderResource: 'Resource',
  tableHeaderUsers: 'Users',
  tableHeaderStart: 'Start',
  tableHeaderEnd: 'End',
  selectedCountries: 'Selected Countries',
  selectedDevices: 'Selected Devices',


  //rules
  alarmRules: 'Alarm Rules',
  btnAddRule: 'Add New Rule',
  ruleText: 'Search works on Alarm Name column',
  applyToLab2: 'All',
  applyToLab3: 'All Controller with Geo Location',
  tableHeaderId: 'ID',
  tableHeaderAlarmName: 'Alarm Name',
  tableHeaderLimit: 'Limit',
  tableHeaderSeverity: 'Severity',
  enableDisable: 'Enable/Disable',
  actions: 'Actions',
  alarmRuleEnabled: 'Enabled',
  alarmRuleDisabled: 'Disabled',
  applyToGroups: 'Groups',
  groupsList: 'Groups List',
  selectGroups: 'Select Groups',



  //telemetry
  tabTitleTelemetry: 'Telemetry',
  filters: 'Filters',
  showFavourites: 'Show Favorites',
  favoritesCol: 'Favorites',
  label: 'Label',
  currentValue: 'Current Value',
  unit: 'Unit',
  operations: 'Operations',
  settingsReadAll: 'Read All',
  tabTitleSettings: 'Settings',
  btnBack: 'BACK',
  lastConnetedOn: 'Last Connected On',
  resourceData: 'Resources Data',
  tagName: 'Tag Name',
  tagText: 'Update Tag or Alias Name',
  btnUpdate: 'Update',
  btnExport: 'Export',
  day: 'DAY',
  week: 'WEEK',
  month: 'MONTH',
  loadData: 'Loading latest telemetry data ... ',
  loadTelemetryData: 'Loading telemetry data ... ',
  noData: 'No Data to display',
  tableHeaderResources: 'Resources',
  tableHeaderMin: 'Min',
  tableHeaderMax: 'Max',
  tableHeaderValue: 'Value',
  tableHeaderUnit: 'Unit',
  tableHeaderAction: 'Select',
  tableHeaderTimeStamp: 'Timestamp',
  commercialName: 'Controller Model',
  selectedResourceData: 'Selected Resources Data',
  last24hr: "Last 24Hr",
  viewData: "View Data",
  note: "Note: Maximum of 8 resources are allowed to view data",
  getData: "Get Data",
  until: "Until",
  setValue: "Set Value",
  //pop-up
  save: 'Save',
  cancel: 'Cancel',
  saveAndApp: 'Save and Apply',
  move: 'Move',
  fail: 'Fail',
  //alarm rules pop-up
  addRule: 'Add Alarm Details',
  updateRule: 'Update Alarm Details',
  alarmType: 'Alarm Type',
  controller: 'Controller',
  resource: 'Resource',
  resources: 'Resources',
  limit: 'Limit',
  min: 'Min',
  max: 'Max',
  notify: 'Notified Email To',
  severity: 'Severity',
  apply: 'Apply To',
  maxdis: 'Max Distance',
  alarmName: 'Alarm Name',
  controllerName: 'Controller Name',
  allControllerIn: 'All Controller In',
  high: 'Critical',
  low: 'Warning',
  parameters: 'Parameters',
  parameter: 'Parameter',
  geoLocation: 'Geo Location',
  selectController: 'Select Controller',
  selectControllers: 'Select Controllers',
  selectResource: 'Select Resource',
  allCountries: 'All Countries Selected',
  selectAllCountries: 'All Countries',
  selectCountry: 'Select Country',
  SelectCountries: 'Select Countries',
  Countries: 'Country List',
  ControllersList: 'Controller List',
  delayInfo1:'The Delay defines how long the condition must persist before triggering the alarm.',
  delayInfo2:'Delay must be multiple of the sampling frequency that is configurable via Eliwell AIR Mobile App.',
  delayInfo: 'The Delay defines how long the condition must persist before triggering the alarm.\nDelay must be multiple of the sampling frequency that is configurable via Eliwell AIR Mobile App.',
  alarmReceiverEmail:'Alarm Receiver Email',
  downloadPdf:'Download PDF',
  downloadCsv:'Download CSV',
  downloadXlsx:'Download Xlsx',

  //reports
  generateReport: 'Generate Report',
  date: 'Date',
  reports: 'Reports',
  registeredTenant: 'Registered Tenant',
  registeredUser: 'Registered Users',
  userUnderTenant: 'Users under Tenant',
  renewalNotify: 'Renewal notification sent to Tenant',
  coolersUnderTenant: 'Number of coolers under Tenant',
  chooseFormat: 'Choose Format',
  select: 'Select',
  coolersByCountry: 'Coolers by Country',
  reportReceiverEmail: 'Report Receiver Email',
  reportFrequencyLabel1: 'The Air Cloud will send everyday the report at 9:00 AM(UTC)',
  reportFrequencyLabel2: 'The Air Cloud will send every week the report on Monday at 9:00 AM(UTC)',
  reportFrequencyLabel3: 'The Air Cloud will send every month the report on the 1st of the month at 9:00 AM(UTC)',
  dataFrequencyCommonLabel:'The Air Cloud will register the',
  onetimeperday:'first measurement detected between 00:00 and 12:00',
  twotimeperday:'first measurement detected between 00:00 and 12:00',
  timeslots1224:'first between 12:00 - 24:00',
  dataFrequencyLabel3:'first measurement in each of these time slots',
  dataFrequencyLabel4:'first measurement in each of these time slots',
  enterValidEmailAddress:'Please enter a valid email address for all entries',

  //map
  activeAlarms: 'Active Alarms',
  associatedResources: 'Associated Resources',
  associatedUsers: 'Associated Users',

  //device
  userDeviceInformation: 'User Device Information',
  mobileName: 'Mobile Name',
  mobileModel: 'Mobile Model',
  mobileSearch: 'Search works on Mobile UID, Mobile Model, Mobile OS|Version columns',
  mobileUId: 'Mobile UId',
  mobileOS: 'Mobile OS | Version',
  mobileIssuedOn: 'Issued On',
  noRecords: 'No Records found',
  billAddress: 'Billing Address',
  noResults: 'No results found!',
  activeDevices: 'Active Device(s)',
  inactiveDevices: 'In-active Device(s)',
  //export
  fromdate: 'Start Date',
  todate: 'End Date',
  selectStartDate: 'Select Start Date',
  selectEndDate: 'Select End Date',
  downloadFaild: 'Faild to download',
  format: 'Format',
  controllers: 'Controllers',
  progressBar: 'Downloads in Progress',

  // Driver Manager
  driverManager: 'Driver Manager',
  driverFileName: 'Driver File Name',
  mask: 'Mask',
  poli: 'Poli',
  uploadedBy: 'Uploaded By',
  uploadedOn: 'Uploaded On',
  choose: "Choose",
  upload: "Upload",
  ruleDetails: 'Rule Details',
  addTag: 'Add Tag Name..',
  close: 'Close',
  disable: 'Disable',
  tenantNote: 'Note: Once disabled you can not enable again.',
  deleteRulehead: 'Delete  Rule',
  deleteUserhead: 'Delete User',
  blockUserHead: 'Block User',
  unblockUserHead: 'Unblock User',
  deleteDevicehead: 'Delete Device',
  aggreeWarn: 'Do you agree?',
  fileExist: 'Driver file already exists',
  overWriteMsg: 'Are you sure you want to Overwrite?',
  infoMessage: 'Are you sure to Delete Driver?',
  warning: 'Warning',
  driverUpload: 'Driver Upload',
  driverUploadSearch: 'Search works on Driver File Name, Mask, and Uploaded By columns',
  haccpReportTitle: 'Search works on Report Name,Report Frequency, and Notified Email columns',
  btnAddReport: 'Add new report',
  reportName: 'Report Name',
  ReportFrequency: 'Report Frequency',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  dataFrequency: 'Data Frequency',
  Pdf: 'PDF',
  Csv: 'CSV',
  Excel: 'XLSX',
  DeleteReportHead: 'Delete Report :',
  AddReport: 'Add Report',
  UpdateReport: 'Update Report Details',
  selectDataFreq: 'Select Data Frequency',
  OneDataFreq: 'One time per day',
  TwoDataFreq: 'Two times per day',
  ThreeDataFreq: 'Three time per day',
  FourDataFreq: 'Four times per day',
  selectDevice: 'Select Device',
  DataFreqMandatory: 'Data Frequency is Mandatory',
  DeviceMandatory: 'Device is Mandatory',
  ResourceMandatory: 'Resource is Mandatory',
  notifyEmailMandatory: ' Notified to email is Mandatory',
  MaxResourceSelected: 'Maximum 8 resources can be selected',
  oid: 'OID',
  oemName: 'OEM Name',
  oemDesc: 'OEM Description',
  oemSearchText: 'Search works on OID,OEM Name,OEM Description,Device Count',
  btnAddOem: 'Add OEM',
  privacyPolicy: 'Privacy Policy',
  termsAndCondition: 'Terms and Conditions',
  version: 'Version',
  history: 'History',
  versionNumber: 'v3.2',
  support: 'Support',
  faq: 'FAQ\'s',
  legal: 'Legal',
  copyright: 'Copyright',
  mapView: 'Map View',
  status: "Status",
  count: "Count",
  modbusSlaveId: 'Modbus Slave Id',
  release: 'Release',
  pch: 'PCH',
  locationContry: 'Location',
  dspId: 'Dsp Id',
  firmwareVersion: 'Firmware Version',
  deviceMetadata: 'Device Metadata',
  alarmCountGroupByDeviceStatus: 'Alarms count group by device\'s status and device',
  alarmCountByStatus: 'Alarms count by device\'s status',
  alarmCountDistributionOverTime: 'Alarm Count distribution over time',
  alarmStatusCountOverTime: 'Alarm status count over time',
  deviceByControllerModel: 'Device by Controller Model',
  selectColumns: 'Select columns',
  columnsSelected: 'columns selected',
  favourites: 'Favourites',
  ///// new  /////
  alarmWhen: 'Alarm when',
  delay: 'Delay',
  minute: 'minute',
  ColorForChart: 'Color',
  addBroadcastMessage: 'Add Broadcast Message',
  editBroadcastMessage:'Edit Broadcast Message',
  broadcastMessage:'Broadcast Message',
  deviceMetadataSearchText: 'Search works on DongleUId,Name,Added by,Mask,Poli,Controller Type Name,Device Type,Modbus slave ID,Release,PCH,Location and Firmware version',

  deleteBroadcastMessage: 'Delete Broadcast Message',
  showMore: 'Show More',
  dateInUTC:'Note: Please select dates in UTC timezone.',

  // App Configuration
  rexOTT: 'REX OTT',
  languageSelection: 'Language Selection',
  token: 'Token',
  copied: 'Copied',
  copy: 'Copy',
  selectLanguage: 'Select Language',

  enterRemoteLink:'Enter Remote Link :',
}
